import React from 'react';
import { IconButton } from '@mui/material';
import { FileCloseIcon, FileErrorIcon, FileIcon } from 'v2/icons';
import styles from './DropzoneFileItem.module.scss';
import classnames from 'classnames';
import { ExtendedDropzoneFile } from 'v2/models';

type DropzoneFileItemProps = {
  onDelete: (file: ExtendedDropzoneFile) => void;
  file: ExtendedDropzoneFile;
};

export function DropzoneFileItem({ file, onDelete }: DropzoneFileItemProps) {
  const fileUploadProgress = file.upload?.progress ?? 0;

  return (
    <div className={styles.dzItemContainer}>
      <div
        className={classnames(
          styles.dzItem,
          Boolean(file.error) && styles.dzItemError
        )}
      >
        <div>{file.error ? <FileErrorIcon /> : <FileIcon />}</div>

        <p className={styles.dzItemFileName}>{file.name}</p>

        {fileUploadProgress < 100 && (
          <div>
            <div data-cy="progressBar" className={styles.dzItemProgress}>
              <span
                style={{
                  width: `${fileUploadProgress}%`,
                }}
              />
            </div>
          </div>
        )}

        <IconButton
          type="button"
          className={styles.dzItemCloseButton}
          data-cy="closeButton"
          onClick={() => {
            onDelete(file);
          }}
        >
          <FileCloseIcon />
        </IconButton>
      </div>

      {Boolean(file.error) && (
        <p data-cy="errorMsg" className={styles.errorMessage}>
          {file.error}
        </p>
      )}
    </div>
  );
}
